export default __webpack_public_path__ + "static/property-img-3-c2c8fbb6e5a07f3d53243486e9b08e71.jpg";